import type { EVMAddress } from "@opensea/utils"
import { useCallback } from "react"
import type { Hex } from "viem"
import type { Connector as WagmiConnector } from "wagmi"
import { useSignMessage } from "wagmi"
import { parseSignatureError } from "../../lib/errors"
import type { SignFunction } from "../../types"
import { useWithConnectorErrorRetry } from "./useWithConnectorErrorRetry"

export const useEvmSignFunction = () => {
  const { signMessageAsync: signMessage } = useSignMessage()

  const withConnectorErrorRetry = useWithConnectorErrorRetry()

  const sign: SignFunction = useCallback(
    async variables => {
      try {
        const signature: Hex = await withConnectorErrorRetry(async () => {
          return await signMessage({
            message: variables.message,
            account: variables.address as EVMAddress,
            connector: variables.connector?.baseConnector as WagmiConnector,
          })
        })
        return signature
      } catch (err: unknown) {
        const error = err as Error
        const externalError = parseSignatureError(error)
        throw externalError
      }
    },
    [signMessage, withConnectorErrorRetry],
  )

  return sign
}
